import React from 'react';
import styles from './Treatments.module.scss';
import {$t} from "../../../helpers/translator";
import TreatmentsTable from "../../../components/TreatmentsTable/TreatmentsTable";

class ChainTreatments extends React.Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {

    }

    render() {
        return (
            <div className={styles.container}>
                <div>
                    <div className={styles['flex-row']}>
                        <div className={styles['box']}>
                            <TreatmentsTable
                                userType={3}
                                header={$t('global.treatments.chainTreatments')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChainTreatments;
